// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1GUis","label":"Labeled_label__3zJ7R","divider":"Labeled_divider__21E1q"};